import { CityFrom } from "./Components/CityFrom";
import { CityTo } from "./Components/CityTo";
import { Datepicker } from "./Components/Datepicker";
import { Filters } from "./Components/Filters";
import { Loader } from "./Components/Loader";
import { Progress } from "./Components/Progress";
import { ItemsWrapper } from './Components/ItemsWrapper';
import { SearchTickets } from "./Components/SearchTickets";
import { Sort } from "./Components/Sort";
import { Passengers } from "./Components/Passengers";
import { NoRoutes } from "./Components/NoRoutes";
import AjaxBuilder from "../../../Common/AjaxBuilder";
import { Util } from "../../../Common/Util";
import { Swap } from "./Components/Swap";
import { ServiceClass } from "./Components/ServiceClass";
import { TicketTypes } from "./Components/TicketTypes";
import { LoadingPopup } from "../Components/LoadingPopup";
import { ErrorPopup } from "../Components/ErrorPopup";
import Vocabulary from "../../../Common/Vocabulary";
import { SearchPopupTimer } from "../../CommonComponents/Search/SearchPopupTimer";

export class AviaSearchModule {
    constructor({ page, handler, search }) {
        this.$page = page;
        this.$searchModule = $('#widget_form');

        this._lang = $('html').attr('lang');

        this._searchTickets = handler;

        this._routes = [];

        this._searchTrigger = search;

        this._getRoutes = this._getRoutes.bind(this);
        this.updateRoutes = this.updateRoutes.bind(this);

        this._init();
    }

    async _init() {
        this._loader = new Loader();

        this._cityFrom = new CityFrom({
            searchModule: this.$searchModule,
            loader: this._loader,
            lang: this._lang,
        });

        this._cityTo = new CityTo({
            searchModule: this.$searchModule,
            loader: this._loader,
            lang: this._lang,
        });

        this._swap = new Swap({
            searchModule: this.$searchModule,
            cityFrom: this._cityFrom,
            cityTo: this._cityTo,
        })

        this._datePicker = new Datepicker({
            searchModule: this.$searchModule,
            lang: this._lang,
        });

        this._searchPopupTimer = new SearchPopupTimer({
            page: this.$page,
            handler: this._searchTickets,
        });

        this._passengers = new Passengers({
            searchModule: this.$searchModule,
        });

        this._serviceClass = new ServiceClass({
            searchModule: this.$searchModule,
        });

        this._searchTicketButton = new SearchTickets({
            searchModule: this.$searchModule,
            handler: this._searchTickets,
        });

        this._itemsWrapper = new ItemsWrapper({
            page: this.$page,
            handler: this._saveSeletedFlight.bind(this),
            getRoutes: this._getRoutes,
        });

        this._noRoutes = new NoRoutes({
            page: this.$page,
            lang: this._lang,
        });

         this._progress = new Progress({
             page: this.$page,
             lang: this._lang,
        });

        this._sort = new Sort({
            page: this.$page,
            itemsWrapper: this._itemsWrapper,
            updateRoutes: this.updateRoutes,
            getRoutes: this._getRoutes,
        });

        this._filters = new Filters({
            page: this.$page,
            updateRoutes: this.updateRoutes,
            getRoutes: this._getRoutes,
        });

        this._ticketTypes = new TicketTypes({
            page: this.$page,
            itemsWrapper: this._itemsWrapper,
            sort: this._sort,
        });

        if (this._searchTrigger) {
             this._progress.show({
                 cityFrom: null,
                 cityTo: null,
                 date: null,
            });

            await this._cityFrom.getCities();
            await this._cityTo.getCities();
            
            this._searchTickets();
        } else {
            await this._cityFrom.getCities();
            await this._cityTo.getCities();
        }

    }

    _updateRoute(cityFrom, cityTo, startDate) {
        const passengers = this._passengers.getPassengersCount();
        const serviceClass = this._serviceClass.getServiceClass();

        let route = `${Util.getLocalization()}avia/search/`;

        route = `${route}${cityFrom.name_en.replace(/ /g, '-').toLowerCase()}/${cityTo.name_en.replace(/ /g, '-').toLowerCase()}/${cityFrom.code.toLowerCase()}/${cityTo.code.toLowerCase()}/${cityFrom.id}/${cityTo.id}/${startDate}/${passengers.addults}/${passengers.children}/${passengers.baby}/${serviceClass}/`;
        window.history.pushState({}, null, route);
    }

    _saveSeletedFlight(event) {
        event.preventDefault();
        event.stopPropagation();

        const selectedItem = event.target;

        LoadingPopup.show();

        const routeId = $(selectedItem).closest('.avia_results_item').data('routeid');
        if (!routeId) {
            LoadingPopup.hide();
            ErrorPopup.show({
                title: Vocabulary[Util.getCurrentLang()].avia.failed_popup.title,
                message: Vocabulary[Util.getCurrentLang()].avia.failed_popup.errorReloadMessage,
            });
            return false;
        }

        const flight = this._getRoutes().find(route => route['id'] === routeId);
        if (!flight) {
            LoadingPopup.hide();
            ErrorPopup.show({
                title: Vocabulary[Util.getCurrentLang()].avia.failed_popup.title,
                message: Vocabulary[Util.getCurrentLang()].avia.failed_popup.errorReloadMessage,
            });
            return false;
        }

        const cityFrom = this._cityFrom.getSelectedCity();
        const cityTo = this._cityTo.getSelectedCity();
        const startDate = this._datePicker.getStartDate();
        const passengers = this._passengers.getPassengersCount();
        const serviceClass = this._serviceClass.getServiceClass();

        new AjaxBuilder({
            route: `${Util.getLocalization()}avia/save-flight/`,
            data: {
                departureCityOrAirportName: cityFrom.name_en,
                departureCityCodeOrAirportsCode: cityFrom.code,
                departureCityOrAirportId: cityFrom.id,
                arrivalCityOrAirportName: cityTo.name_en,
                arrivalCityCodeOrAirportsCode: cityTo.code,
                arrivalCityOrAirportId: cityTo.id,
                departureDate: startDate,
                serviceClass: serviceClass,
                passengers: passengers,
                session_id: flight.session_id,
                flight_id: flight.id,
                apiName: 'Tickets',
                flight: flight,
            },
            token: Util.token(),
        }, 'POST').execute({
            success: this._saveSelectedRouteSuccess.bind(this),
            error: this._saveSelectedRouteError.bind(this),
        });
    }

    _saveSelectedRouteSuccess(response) {
        LoadingPopup.hide();

        const cityFrom = this._cityFrom.getSelectedCity();
        const cityTo = this._cityTo.getSelectedCity();
        const startDate = this._datePicker.getStartDate();
        const passengers = this._passengers.getPassengersCount();
        const serviceClass = this._serviceClass.getServiceClass();

        const route = `${Util.getLocalization()}avia/passengers/${cityFrom.name_en.replace(/ /g, '-').toLowerCase()}/${cityTo.name_en.replace(/ /g, '-').toLowerCase()}/${cityFrom.code.toLowerCase()}/${cityTo.code.toLowerCase()}/${cityFrom.id}/${cityTo.id}/${startDate}/${passengers.addults}/${passengers.children}/${passengers.baby}/${serviceClass}/`;
        window.location = route;
    }

    _saveSelectedRouteError(response) {
        console.error(response);
        LoadingPopup.hide();
        ErrorPopup.show({
            title: Vocabulary[Util.getCurrentLang()].avia.failed_popup.title,
            message: Vocabulary[Util.getCurrentLang()].avia.failed_popup.errorReloadMessage,
        });
    }

    _getRoutes() {
        return this._routes;
    }

    updateRoutes(routes) {
        this._routes = routes;
        return this;
    }

    _scrollToTop() {
        $('html, body').animate({ scrollTop: 0 }, 500);
    }
}
